import React, { useState } from "react";
import MuiCheckbox from "./MuiCheckbox";

interface Product {
    id: string;
    name: string;
    img: string;
    seller: string;
    maxQty: number;
    checked: boolean;
    qty: number;
}

const initialData: Product[] = [
    {
        id: "1",
        name: "Concor 5.0mg merck (h/30v)",
        img: "https://gcs.buymed.com/thuocsi-live/images/202454df4f869b8609b11cda9475236e?width=150&quality=80",
        seller: "Merck Healthcare",
        maxQty: 159,
        checked: false,
        qty: 0,
    },
    {
        id: "2",
        name: "Waisan eperison 50mg bidiphar (h/100v)",
        img: "https://gcs.buymed.com/thuocsi-live/innovation/retrieval/2024b417517e4844ab12f494352473f611872.png?width=150&quality=80",
        seller: "Dược phẩm Bidiphar",
        maxQty: 266,
        checked: false,
        qty: 0,
    },
    {
        id: "3",
        name: "Glucophage 850mg merck (h/100v)",
        img: "https://gcs.buymed.com/thuocsi-live/images/20242e602292c9e10fd5600657eeaffb?width=150&quality=80",
        seller: "Merck Healthcare",
        maxQty: 60,
        checked: false,
        qty: 0,
    },
];

export default function WishlistList() {
    const [products, setProducts] = useState<Product[]>(initialData);

    const totalChecked = products.filter(p => p.checked).length;
    const allChecked = totalChecked === products.length && products.length > 0;
    const indeterminate = totalChecked > 0 && totalChecked < products.length;

    const toggleCheckItem = (id: string) => {
        setProducts(prev =>
            prev.map(p =>
                p.id === id ? { ...p, checked: !p.checked } : p
            )
        );
    };

    const toggleCheckAll = () => {
        const target = !(allChecked && !indeterminate);
        setProducts(prev => prev.map(p => ({ ...p, checked: target })));
    };

    const deleteSelected = () => {
        setProducts(prev => prev.filter(p => !p.checked));
    };

    const changeQty = (id: string, value: number) => {
        setProducts((prev) =>
            prev.map((p) =>
                p.id === id
                    ? { ...p, qty: Math.max(0, Math.min(value, p.maxQty)) }
                    : p
            )
        );
    };

    return (
        <div className="MuiGrid-root MuiGrid-container MuiGrid-direction-xs-column">
            <header className="MuiPaper-root MuiAppBar-root MuiAppBar-positionFixed MuiAppBar-colorPrimary styles_appBar__Kzodx mui-fixed MuiPaper-elevation4 w-full-1199-24px show-1199">
                <div className="MuiToolbar-root MuiToolbar-regular styles_toolBar__DQTee MuiToolbar-gutters">
                    <a href="/" className="MuiButtonBase-root MuiButton-root MuiButton-text styles_btnHamburger__POqzB" type="button" aria-label="back pagehome">
                        <span className="MuiButton-label">
                            <span style={{ boxSizing: "border-box", display: "inline-block", overflow: "hidden", width: "initial", height: "initial", background: "none", opacity: 1, border: "0px", margin: "0px", padding: "0px", position: "relative", maxWidth: "100%" }}>
                                <span style={{ boxSizing: "border-box", display: "block", width: "initial", height: "initial", background: "none", opacity: 1, border: "0px", margin: "0px", padding: "0px", maxWidth: "100%" }}>
                                    <img alt="" aria-hidden="true" src="data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%2724%27%20height=%2724%27/%3e" style={{ display: "block", maxWidth: "100%", width: "initial", height: "initial", background: "none", opacity: 1, border: "0px", margin: "0px", padding: "0px" }} />
                                </span>
                                <img src="https://cdn-web-mobile-next.thuocsi.vn/images/header-v2/arrow-left.svg" decoding="async" data-nimg="intrinsic" style={{ position: "absolute", inset: "0px", boxSizing: "border-box", padding: "0px", border: "none", margin: "auto", display: "block", width: "0px", height: "0px", minWidth: "100%", maxWidth: "100%", minHeight: "100%", maxHeight: "100%" }} />
                            </span>
                        </span>
                        <span className="MuiTouchRipple-root"></span>
                    </a>
                    <p className="MuiTypography-root styles_formTitle__o8AZx MuiTypography-body1">Sản phẩm quan tâm</p>
                </div>
            </header>
            <div className="styles_searchWrapper__1VsnB show-1199">
                <div className="MuiInputBase-root MuiInput-root styles_root_input__fUHE5 MuiInputBase-adornedStart">
                    <svg className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-1a5basm" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="SearchIcon">
                        <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"></path>
                    </svg>
                    <input placeholder="Nhập tên thuốc, hoạt chất cần tìm" type="search" className="MuiInputBase-input MuiInput-input styles_input__p8e0Z MuiInputBase-inputAdornedStart MuiInputBase-inputTypeSearch MuiInput-inputTypeSearch" value="" />
                </div>
            </div>
            <div className="style_wrapperContent__9ddkL">

                {/* ==== TOP BAR ==== */}
                <div className="style_containerTop__j5JB3">
                    <span className="style_titleContent__NuXwE">
                        Danh sách sản phẩm bạn quan tâm
                    </span>

                    <div className="style_rightContent__ql1ZG">

                        {/* Delete */}
                        <button
                            type="button"
                            className="MuiButtonBase-root style_buttonDelete__qgtWb style_check__aDusd"
                            onClick={deleteSelected}
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M7.22866 14.3957C7.47053 14.3957 7.67683 14.3094 7.84756 14.1367C8.01829 13.9496 8.10366 13.7338 8.10366 13.4892V8.09352C8.0752 7.8777 7.97561 7.69784 7.80488 7.55396C7.63415 7.39568 7.43496 7.31655 7.20732 7.31655C6.9939 7.31655 6.80183 7.39568 6.6311 7.55396C6.46037 7.69784 6.36077 7.8777 6.33232 8.09352V13.4892C6.33232 13.7338 6.41768 13.9496 6.58841 14.1367C6.77337 14.3094 6.98679 14.3957 7.22866 14.3957ZM16.1067 3.60432H12.564V2.69784C12.564 2.20863 12.4431 1.76259 12.2012 1.35971C11.9594 0.942445 11.6321 0.61151 11.2195 0.366906C10.8211 0.122302 10.3801 0 9.89634 0H8.10366C7.61992 0 7.17175 0.122302 6.75915 0.366906C6.36077 0.61151 6.04065 0.942445 5.79878 1.35971C5.55691 1.76259 5.43598 2.20863 5.43598 2.69784V3.60432H1.89329C1.67988 3.63309 1.49492 3.73381 1.33841 3.90647C1.19614 4.07914 1.125 4.28058 1.125 4.51079C1.125 4.72662 1.19614 4.92086 1.33841 5.09352C1.49492 5.26619 1.67988 5.36691 1.89329 5.39568H2.76829V15.3022C2.76829 15.7914 2.88923 16.2374 3.1311 16.6403C3.37297 17.0576 3.69309 17.3885 4.09146 17.6331C4.50407 17.8777 4.95224 18 5.43598 18H12.564C13.0478 18 13.4888 17.8777 13.8872 17.6331C14.2998 17.3885 14.627 17.0576 14.8689 16.6403C15.1108 16.2374 15.2317 15.7914 15.2317 15.3022V5.39568H16.1067C16.3201 5.36691 16.498 5.26619 16.6402 5.09352C16.7967 4.92086 16.875 4.72662 16.875 4.51079C16.875 4.28058 16.7967 4.07914 16.6402 3.90647C16.498 3.73381 16.3201 3.63309 16.1067 3.60432ZM7.22866 2.69784C7.22866 2.45324 7.31402 2.2446 7.48476 2.07194C7.65549 1.89928 7.86179 1.81295 8.10366 1.81295H9.89634C10.1382 1.81295 10.3445 1.89928 10.5152 2.07194C10.686 2.2446 10.7713 2.45324 10.7713 2.69784V3.60432H7.22866V2.69784ZM13.439 15.3022C13.439 15.5468 13.3537 15.7554 13.1829 15.9281C13.0122 16.1007 12.8059 16.187 12.564 16.187H5.43598C5.19411 16.187 4.9878 16.1007 4.81707 15.9281C4.64634 15.7554 4.56098 15.5468 4.56098 15.3022V5.39568H13.439V15.3022ZM10.7713 14.3957C11.0132 14.3957 11.2195 14.3094 11.3902 14.1367C11.5752 13.9496 11.6677 13.7338 11.6677 13.4892V8.09352C11.6392 7.8777 11.5396 7.69784 11.3689 7.55396C11.1982 7.39568 10.999 7.31655 10.7713 7.31655C10.5579 7.31655 10.3659 7.39568 10.1951 7.55396C10.0244 7.69784 9.9248 7.8777 9.89634 8.09352V13.4892C9.89634 13.7338 9.98171 13.9496 10.1524 14.1367C10.3232 14.3094 10.5295 14.3957 10.7713 14.3957Z" fill="#005c29"></path></svg>
                            <span>Xóa khỏi danh sách</span>
                        </button>

                        {/* Select all */}
                        <div
                            className="style_wrapperCheckbox__sBg1i style_check__aDusd"
                            onClick={toggleCheckAll}
                        >
                            <span>Chọn tất cả</span>
                            <MuiCheckbox
                                checked={allChecked}
                                indeterminate={indeterminate}
                                onChange={toggleCheckAll}
                            />
                        </div>
                    </div>
                </div>

                {/* ==== SEARCH ==== */}

                <div className="MuiFormControl-root MuiTextField-root style_root_input__8oRc3 style_root_input_search__RBL1w hidden-1199">
                    <div className="MuiInputBase-root MuiInput-root MuiInput-underline MuiInputBase-formControl MuiInput-formControl MuiInputBase-adornedStart">
                        <div className="MuiInputAdornment-root style_search_ic__W9sB1 MuiInputAdornment-positionStart">
                            <span style={{ boxSizing: "border-box", display: "inline-block", overflow: "hidden", width: "initial", height: "initial", background: "none", opacity: 1, border: "0px", margin: "0px", padding: "0px", position: "relative", maxWidth: "100%" }}>
                                <span style={{ boxSizing: "border-box", display: "block", width: "initial", height: "initial", background: "none", opacity: 1, border: "0px", margin: "0px", padding: "0px", maxWidth: "100%" }}>
                                    <img alt="" aria-hidden="true" src="data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%2718%27%20height=%2718%27/%3e" style={{ display: "block", maxWidth: "100%", width: "initial", height: "initial", background: "none", opacity: 1, border: "0px", margin: "0px", padding: "0px" }} />
                                </span>
                                <img data-origin-url="https://cdn-web-next.thuocsi.vn/images/header-v2/SearchActive_icon.svg" src="https://cdn-web-next.thuocsi.vn/images/header-v2/SearchActive_icon.svg" decoding="async" data-nimg="intrinsic" style={{ position: "absolute", inset: "0px", boxSizing: "border-box", padding: "0px", border: "none", margin: "auto", display: "block", width: "0px", height: "0px", minWidth: "100%", maxWidth: "100%", minHeight: "100%", maxHeight: "100%" }} />
                            </span>
                        </div>
                        <input aria-invalid="false" autoComplete="off" placeholder="Tìm kiếm tên thuốc trong danh sách sản phẩm quan tâm" type="search" maxLength={250} className="MuiInputBase-input MuiInput-input MuiInputBase-inputAdornedStart MuiInputBase-inputTypeSearch MuiInput-inputTypeSearch" value="" />
                    </div>
                </div>

                {/* ==== PRODUCT LIST ==== */}
                {products.map((p) => (
                    <div key={p.id} className="style_wrapperCard__yyX_D">

                        <div className="styles_cardContainer__roWvH style_cardItem__rKGSb">
                            <div className="styles_flex__YOT7Y">

                                {/* image */}
                                <a href="#">
                                    <div className="styles_wrapperImage__vkqUl">
                                        <img src={p.img} alt={p.name} />
                                    </div>
                                </a>

                                {/* info */}
                                <div className="styles_wrapperInfoProduct__zIAXY">
                                    <span className="styles_name__JFs3F">{p.name}</span>
                                    <div className="styles_sellerContainer__zCB_8">
                                        <span style={{ boxSizing: "border-box", display: "inline-block", overflow: "hidden", width: "initial", height: "initial", background: "none", opacity: 1, border: "0px", margin: "0px", padding: "0px", position: "relative", maxWidth: "100%" }}>
                                            <span style={{ boxSizing: "border-box", display: "block", width: "initial", height: "initial", background: "none", opacity: 1, border: "0px", margin: "0px", padding: "0px", maxWidth: "100%" }}>
                                                <img alt="" aria-hidden="true" src="data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%2713%27%20height=%2713%27/%3e" style={{ display: "block", maxWidth: "100%", width: "initial", height: "initial", background: "none", opacity: 1, border: "0px", margin: "0px", padding: "0px" }} />
                                            </span>
                                            <img src="https://cdn-web-next.thuocsi.vn/icons/seller_store.svg" decoding="async" data-nimg="intrinsic" style={{ position: "absolute", inset: "0px", boxSizing: "border-box", padding: "0px", border: "none", margin: "auto", display: "block", width: "0px", height: "0px", minWidth: "100%", maxWidth: "100%", minHeight: "100%", maxHeight: "100%" }} />
                                        </span>
                                        <a className="styles_cardNameStore__T1gCP" target="_blank" href="/flagship-store/merck-healthcare">Merck Healthcare</a>
                                    </div>
                                    <div className="styles_cardBadges__umsyP MuiBox-root css-0">
                                        <a className="styles_mobile_rootBase__8z7PQ" target="_blank" href="/deals">
                                            <img alt="tag-/deals" src="https://gcs.buymed.com/thuocsi-live/internal/cms/2024e1a6ffa3d0111cad282d9eeed6f3Tag_Label_-_Icon+Text-5.svg" title="Khuyến Mãi" />
                                        </a>
                                    </div>
                                </div>
                            </div>

                            <div className="styles_wrapperContent__K5zzD">
                                <div className="styles_wrapperDiscount__H_zPT">
                                    <p className="MuiTypography-root styles_promo__Q5YiA MuiTypography-body1"> -1%</p>
                                    <a className="styles_cardDiscount__HubGJ" href="/product/medx-concor-5.0mg-merck-h30v">
                                        <div className="styles_flex_no_wrap__1vvft MuiBox-root css-0">
                                            <div className="styles_canvasPrice__vw932 text-[15px] line-through text-[#333333]" style={{ height: "25px" }}>128.600đ</div>
                                        </div>
                                    </a>
                                </div>
                                <div>
                                    <a className="" href="/product/medx-concor-5.0mg-merck-h30v">
                                        <div className="styles_flex_no_wrap__1vvft MuiBox-root css-0">
                                            <div className="styles_canvasPrice__vw932 text-[22px] text-[#005c29]" style={{ height: "34px" }}>125.600đ</div>
                                        </div>
                                    </a>
                                </div>
                            </div>

                            {/* ==== quantity control ==== */}
                            <div className="styles_wrapperQuantityControl__LHcc9">
                                <span className="styles_cardNoted__fnyQc">
                                    Đặt tối đa {p.maxQty} sản phẩm
                                </span>

                                <div className="styles_maxWidth__qS6it">
                                    <div className="styles_container___oLk_ styles_quantityControlContainer__1mAaj qty-control-viewed-wrapper">

                                        {/* minus */}
                                        <div
                                            className="styles_minusContainerNew__flGSc qty-control-viewed-minus"
                                            onClick={() => changeQty(p.id, p.qty - 1)}
                                        >
                                            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none"><path d="M7 12H17" stroke="#333333" stroke-width="2" stroke-linecap="round"></path></svg>
                                        </div>

                                        {/* input */}
                                        <div className="styles_groupInput__H1lLR qty-control-viewed-input-group">
                                            <div className="styles_cartIconContainer__FoKUV">
                                                <div className="styles_inputVisible__m_CzR">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                                        <path d="M14.3608 3.9375H4.00136L3.11622 2.35095C3.01687 2.17287 2.82892 2.0625 2.625 2.0625H1.5C1.18934 2.0625 0.9375 2.31434 0.9375 2.625C0.9375 2.93566 1.18934 3.1875 1.5 3.1875H2.2947L3.16822 4.75324L5.18278 9.21066L5.18484 9.21521L5.36228 9.60781L3.33965 11.7653C3.19422 11.9204 3.14869 12.1443 3.22199 12.3439C3.29529 12.5435 3.47488 12.6847 3.68614 12.7089L5.52974 12.9196C7.83575 13.1831 10.1643 13.1831 12.4703 12.9196L14.3139 12.7089C14.6225 12.6736 14.8442 12.3948 14.8089 12.0861C14.7736 11.7775 14.4948 11.5559 14.1861 11.5911L12.3425 11.8018C10.1214 12.0557 7.87861 12.0557 5.65749 11.8018L4.92585 11.7182L6.41038 10.1347C6.42474 10.1194 6.43808 10.1035 6.45039 10.0871L7.015 10.1605C7.8062 10.2635 8.60596 10.2837 9.40134 10.2208C11.2564 10.074 12.9758 9.19131 14.1761 7.7693L14.6097 7.25569C14.6242 7.23844 14.6377 7.22033 14.6501 7.20146L15.4581 5.97007C16.0309 5.09724 15.4048 3.9375 14.3608 3.9375Z" fill="#999999">
                                                        </path>
                                                        <path d="M4.875 13.875C4.25368 13.875 3.75 14.3787 3.75 15C3.75 15.6213 4.25368 16.125 4.875 16.125C5.49632 16.125 6 15.6213 6 15C6 14.3787 5.49632 13.875 4.875 13.875Z" fill="#999999"></path>
                                                        <path d="M12 15C12 14.3787 12.5037 13.875 13.125 13.875C13.7463 13.875 14.25 14.3787 14.25 15C14.25 15.6213 13.7463 16.125 13.125 16.125C12.5037 16.125 12 15.6213 12 15Z" fill="#999999"></path>
                                                    </svg>
                                                </div>
                                                <span className="styles_currentValue__b2ijJ">1</span>
                                            </div>
                                            <div className="MuiInput-root MuiInputBase-root MuiInputBase-colorPrimary styles_newCardInput__hecWu qty-control-viewed-input css-1f63zq5">
                                                <input
                                                    type="number"
                                                    className="MuiInput-input MuiInputBase-input css-mnn31"
                                                    value={p.qty}
                                                    onChange={(e) =>
                                                        changeQty(p.id, Number(e.target.value))
                                                    }
                                                />
                                            </div>
                                        </div>

                                        {/* plus */}
                                        <div
                                            className="styles_addContainerNew__v_8_6"
                                            onClick={() => changeQty(p.id, p.qty + 1)}
                                        >
                                            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none"><path d="M12 17V7" stroke="#005c29" stroke-width="2" stroke-linecap="round"></path><path d="M7 12L17 12" stroke="#005c29" stroke-width="2" stroke-linecap="round"></path></svg>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* checkbox each item */}
                        <MuiCheckbox
                            checked={p.checked}
                            indeterminate={false}
                            onChange={() => toggleCheckItem(p.id)}
                        />
                    </div>
                ))}

                <span className="style_finishScroll__8c9dA">
                    Đã hết số lượng sản phẩm quan tâm
                </span>
            </div>
        </div>
    );
}
